import React from 'react';
import { ActivityIndicator, Pressable, Text, View } from 'react-native';
import { Icon } from '@ant-design/react-native';
import { colorPalette } from '@shared/config/colorsConfig';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';
import { DOCUMENTS_ROW } from '../../constants';
import type { TDocumentRowProps } from '../../types';
import { formatDocumentMeta } from '../../utils/documentMeta';
import { DocumentNewTag } from './DocumentNewTag';
import { DocumentStatusPill } from './DocumentStatusPill';
import { DocumentTypeIcon } from './DocumentTypeIcon';

export const DocumentRow = ({ item, doctorGender, isOpening, onPress }: TDocumentRowProps) => {
    const { t } = dynamicTranslations();
    const title = item.title ?? t(`documents.kind.${item.kind}`);

    return (
        <Pressable
            onPress={onPress}
            disabled={isOpening}
            accessibilityRole="button"
            className="min-h-[88px] flex-row items-center gap-sm rounded-[16px] border border-gray-300 bg-white px-sm py-sm shadow-sm"
        >
            <DocumentTypeIcon kind={item.kind} />
            <View className="flex-1 min-w-0 gap-xs">
                <Text numberOfLines={2} className="text-base font-semibold text-black">
                    {title}
                </Text>
                <Text numberOfLines={2} className="text-md font-normal text-gray-500">
                    {formatDocumentMeta(item, t)}
                </Text>
                {item.status !== null && <DocumentStatusPill status={item.status} doctorGender={doctorGender} />}
            </View>
            <View className="flex-row items-center gap-sm shrink-0">
                {item.isNew && <DocumentNewTag />}
                {isOpening ? (
                    <ActivityIndicator color={colorPalette.gray[500]} />
                ) : (
                    <Icon name="right" size={DOCUMENTS_ROW.chevronSize} color={colorPalette.gray[500]} />
                )}
            </View>
        </Pressable>
    );
};
